import React, { useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { ContextSnackbar } from "../../context/context_components/snackbar";
import { Collapse, Stack } from "@mui/material";
import { context_header_styles } from "../../context/context_builder_dark_styles";
import { useDrag } from "@use-gesture/react";
import { projectInfoActions, contextBuilderActions } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Default from "./Default";
import DotLoaderImg from "./DotLoaderImg";
import RightSideTabs from "../RightSideTabs";
import StickyButton from "../CustomComponents/StickyButton";
import { setActiveProjectIC } from "../../store/comprehensiveImageViewer/imageViewerlikeContext";

const ImageViewer = ({ toggleComponent }) => {
  const pos = useSelector((state) => state.contextBuilderStore.pos);
  const selectedPage = useSelector((state) => state.contextBuilderStore.page);
  const openContext = useSelector(
    (state) => state.contextBuilderStore.openContext
  );
  const { activeProject } = useSelector((state) => state.imageViewerStore);
  const { projectInfo, projects } = useSelector(
    (state) => state.projectInfoStore
  );
  const dispatch = useDispatch();
  const { optixData, sdkData, mobileData, imageData } = useSelector(
    (state) => state.imageViewerStore
  );
  const bind = useDrag(({ event, offset: [x, y] }) => {
    const targetClasses = event.target.classList;

    // Check if the drag icon is being dragged
    if (targetClasses.contains("drag-indicator-dark")) {
      dispatch(
        contextBuilderActions.setPos({
          x: x + (window.innerWidth - 325),
          y: y + 100,
        })
      );
    }
  });

  const [springs, api] = useSpring(() => ({
    from: {
      x: window.innerWidth - 300,
    },
    config: {
      mass: 2.5,
    },
  }));

  useEffect(() => {}, [selectedPage]);

  useEffect(() => {
    dispatch(contextBuilderActions.setPos(pos));
    if (activeProject === "thailand-live") {
      dispatch(
        projectInfoActions.changeProjectConfig([
          "Thailand",
          "Live",
          "opti_live1",
        ])
      );
      dispatch(setActiveProjectIC("thailand-live"));
    } else {
      dispatch(
        projectInfoActions.changeProjectConfig(["India", "Live", "ira-india"])
      );
      dispatch(setActiveProjectIC("india-live"));
    }
  }, [pos, dispatch]);

  useEffect(() => {
    api.start({
      from: {
        x: "-100%",
        scale: 0,
      },
      to: {
        x: "0%",
        scale: 1,
      },
    });
  }, [openContext]);

  const pages = [
    {
      name: "default",
      page: <Default />,
    },
    // {
    //   name: "projects",
    //   page: (
    //     <ProjectSwitcher />
    //   )
    // }
  ];
  const handleContextOpen = () => {
    dispatch(contextBuilderActions.setPos({ x: pos.x, y: pos.y }));
    dispatch(contextBuilderActions.setopenContext(!openContext));
  };

  useEffect(() => {
    setInterval(() => {
      const updatedDateTime = moment(new Date()).format(
        "MMM DD, YYYY hh:mm:ss a"
      );
      dispatch(projectInfoActions.updateDateTime(updatedDateTime));
    }, 1000);
  }, []);
  const currentPage = pages.filter((page) => page.name === selectedPage)[0][
    "page"
  ];
  const selectedProject =
    projectInfo[0] === "Thailand" ? "thailand-live" : "india-live";

  return (
    <>
      <animated.div
        {...bind()}
        style={{
          position: "fixed",
          zIndex: 999,
          top: pos.y,
          left: pos.x,
          // ...springs,
        }}
      >
        <Stack spacing={0.7}>
          <div className="drag-indicator-dark" style={context_header_styles}>
            <div
              onClick={handleContextOpen}
              style={{
                color: "rgb(250,250,250)",
                fontSize: "1.25rem",
                letterSpacing: "0.02rem",
                cursor: "pointer",
                textShadow: "0 0 3px #fff",
              }}
            >
              image viewer
            </div>
            <div style={{ justifyContent: "center", alignItems: "center" }}>
              <DotLoaderImg />
            </div>
            <DragIndicatorIcon
              sx={{
                fontSize: "1.7rem",
                cursor: "pointer",
                transform: "rotate(90deg)",
              }}
            />
          </div>

          <Collapse in={openContext} timeout={350} unmountOnExit>
            {currentPage}
          </Collapse>

          <ContextSnackbar />
        </Stack>
      </animated.div>
      {(sdkData.length !== 0 || imageData.length !== 0) && (
        <RightSideTabs
          data={imageData}
          project={selectedProject}
          type="imgContext"
          setWidth="99%"
          setTop="0rem"
          mobileWidth="19%"
        />
      )}
      <StickyButton
        content="Image Viewer"
        toggleComponent={toggleComponent}
        toggleContent="imagesTab"
      />
    </>
  );
};

export default ImageViewer;
